import { render, staticRenderFns } from "./ThefranchiseNavbarVertical.vue?vue&type=template&id=360fc5f1&"
import script from "./ThefranchiseNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./ThefranchiseNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports